import { KustomerWidgetEventTypes } from 'widget/types';

// routes
export const CONVERSATIONS_PATH = 'conversations';
export const MESSAGE_THREAD_PATH = 'message_thread';
export const KB_ARTICLE_PATH = 'kb-article';
export const KB_DEFLECT_ARTICLE_PATH = 'kb-deflect-article';
export const KB_SEARCH_PATH = 'kb-search';
export const MODAL_ROOT_ID = 'kustomer-ui-modal-root';

export const WIDGET_TYPE_CHAT = 'chat';

export const WIDGET_TYPE_KB = 'kb';

export const WIDGET_TYPE_CHAT_KB = 'chat-kb';

// KustomerWidgetEventTypes
export const kustomerWidgetEventTypes: Record<
  string,
  KustomerWidgetEventTypes
> = {
  onUnread: 'onUnread',
  onConversationCreate: 'onConversationCreate',
  onOpen: 'onOpen',
  onClose: 'onClose',
  onLogin: 'onLogin',
  onLogout: 'onLogout',
  onUrlPreviewReceived: 'onUrlPreviewReceived',
  onSessionCustomAttributesUpdated: 'onSessionCustomAttributesUpdated',
  onSessionOpened: 'onSessionOpened',
};

export const DEFAULT_SESSION_PAGE_SIZE = 100;
/** Safety cap when prefetching all chat session history pages (matches iOS “load every page before UI” behavior). */
export const MAX_SESSION_HISTORY_PREFETCH_ITERATIONS = 500;
export const OFFLINE = 'offline';

/** Parent → iframe: update chat history status filter (see `widget_api.ts`). */
export const KUSTOMER_HISTORY_STATUS_FILTER_EVENT =
  'kustomerHistoryStatusFilter';
/** Parent → iframe: update CRM-style custom history filter clauses. */
export const KUSTOMER_CUSTOM_HISTORY_FILTER_EVENT =
  'kustomerCustomHistoryFilter';

// URL Unfurler UTM tracking
export const URL_UNFURLER_UTM_SOURCE = 'kustomer_url_preview';
export const URL_UNFURLER_UTM_PARAM = 'utm_source';
